export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-v1-480-430203f669b3242848f6146a0cbf9149.png";